export default "__VITE_ASSET__ClyfLxwq__"